import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Resolve,
  RouterStateSnapshot
} from '@angular/router';
import { firstValueFrom } from 'rxjs';
 
import { ProfileModel } from '../models/profile.model';
import { AuthenticationService } from '../services/authentication/authentication.service';
import { DataService } from '../services/data/data.service';
import { HomeService } from '../services/home-service/home.service';
 
@Injectable({
  providedIn: 'root',
})

export class AuthorityResolverService implements Resolve<ProfileModel> {

  constructor(private dataService: DataService, private auth:AuthenticationService,private homeService:HomeService) {
  }
 
  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<ProfileModel> {
    const id = route.paramMap.get("itemId");
    const item = await firstValueFrom(this.dataService.getAuthority(id));
    if (item && Object.keys(item).length > 1) {
      return item;
    } else {
      // id not found
      const user = await this.auth.getUser();
      if (user.role == "admin" || user.role == "authority") {
        const newItem = <ProfileModel>{
          status: "new",
          role: "authority",
          details: {
            address: {},
            paymentModes: {},
            geocoding: {
              address: {}
            },
            shortDetails: {},
            fullDetails: {},
            labels: {
              bio: false,
              bioConversion:false,
              labelRouge:false,
              aop:false,
              igp:false,
              pecheDurable:false
            },
            role: "authority"
          },
          products: {
            freeText: "",
            references: {}
          },
          private: {
            notifications: {
              newOrder: {
                email: true,
                app: true
              }
            }
          }
        };
        return newItem;
      } else {
        this.homeService.navigateToHome("unknown");
      }
    }
  }
}